"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectContextMenu = void 0;
/* eslint-disable import/prefer-default-export */
const reselect_1 = require("reselect");
exports.selectContextMenu = (0, reselect_1.createSelector)((state) => state.contextmenu, (contextmenu) => contextmenu);
